import { render, staticRenderFns } from "./CollapsedSettingCard.vue?vue&type=template&id=3f8075d0&"
import script from "./CollapsedSettingCard.vue?vue&type=script&lang=js&"
export * from "./CollapsedSettingCard.vue?vue&type=script&lang=js&"
import style0 from "./CollapsedSettingCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports